<template>
  <div class="md-layout text-center">
    <notifications></notifications>
    <form
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
      @submit.prevent="login"
    >
      <login-card header-color="green">
        <h3 slot="title" class="title">
          <md-icon class="md-size-2x text-secondary mb-0 white">exit_to_app</md-icon>Iniciar sesión
        </h3>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>face</md-icon>
          <label>Usuario</label>
          <md-input v-model="user.email" id="email"></md-input>
        </md-field>

        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Contraseña</label>
          <md-input v-model="user.password" type="password" id="password"></md-input>
        </md-field>
        <a href="/home" slot="inputs">Olvide mi Contraseña</a>

        <md-button
          type="submit"
          slot="footer"
          class="md-simple md-primary md-lg"
          id="submit"
          :disabled="loading || loggedIn"
        >
          <md-progress-spinner :md-diameter="20" v-if="loading" md-mode="indeterminate" />
          {{ loading ? "Entrando..." : "Entrar" }}
        </md-button>
      </login-card>
    </form>
  </div>
</template>

<script>
import { LoginCard } from "../../components/";
import authService from "@/services/auth";
import accountService from "@/services/account";
import Vue from "vue";

const DEFAULT_ROUTE = {
  name: "Dashboard",
};

const MAX_TOKENS_STR = "Maximum amount of tokens";

const TRANSLATED_MESSAGE = "Ya ha iniciado sesión";

export default {
  name: "Login",
  components: { LoginCard },
  data() {
    return {
      loading: false,
      loggedIn: false,
      user: {
        email: "",
        password: "",
      },
      initial: "Initial Value",
    };
  },
  methods: {
    login() {
      this.loading = true;
      authService
        .login(this.user)
        .then(() => {
          this.loggedIn = true;
          accountService
            .find()
            .then(() => {
              const { nextURL } = this.$route.query;
              const route = nextURL ? { path: nextURL } : DEFAULT_ROUTE;
              Vue.router.push(route);
            })
            .catch((e) => {
              this.$notify({
                message: `Error login in: ${e}`,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "bottom",
                type: "danger",
              });
            });
        })
        .catch((e) => {
          this.loggedIn = false;
          let message = e.toString();

          if (message.includes(MAX_TOKENS_STR)) {
            this.logoutFromOtherLocations();
          } else {
            this.$notify({
              message,
              icon: "add_alert",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    logoutFromOtherLocations() {
      const message = TRANSLATED_MESSAGE;
      this.$fire({
        icon: "warning",
        title: message,
        text: "Solo se permite una sesión por usuario. Se cerrara su sesión en otros dispositivos.",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((res) => {
        if (!res.value) {
        } else {
          const { email: username, password } = this.user;
          authService
            .apiLogout({ username, password })
            .then(() => this.login());
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 3em;
  font-weight: bold;
  padding: 1.2em 0;
}

.md-layout,
.md-layout-item {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue